import { render, staticRenderFns } from "./UserNotifications.vue?vue&type=template&id=086a650e&scoped=true"
import script from "./UserNotifications.vue?vue&type=script&lang=js"
export * from "./UserNotifications.vue?vue&type=script&lang=js"
import style0 from "./UserNotifications.vue?vue&type=style&index=0&id=086a650e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086a650e",
  null
  
)

export default component.exports